import ChangeLang from "./ChangeLang";
import './index.css';

export default ChangeLang;